<template>
	<div class="row">
		<promo-bar
			v-for="(promo, index) in promos"
			v-show="shouldCreatePromoBar(promo)"
			:key="index"
			:promo="promo"
			@removePromo="removePromo"
		/>

		<!-- <christmas-19-flash-banner /> -->
	</div>
</template>

<script>
import { mapState } from "vuex";
import { isMobile } from "../../util/helpers";
import CONSTANTS from "../../config/constants";
import PromoBar from "../../components/store/promo-bar";
// import Christmas19FlashBanner from "./flash-banners/christmas-19-flash-banner";

export default {
	name: "PromosBars",
	components: {
		PromoBar
		// Christmas19FlashBanner
	},
	data() {
		return {
			promos: null
		};
	},
	computed: {
		...mapState({
			countryCode: state => state.User.location.country_code
		})
	},
	created() {
		this.getPromos();
	},
	methods: {
		getPromos() {
			axios
				.get(`/sites/${CONSTANTS.SITES.LETSBLD}/promos`)
				.then(({ data: promos }) => {
					this.promos = promos.filter(
						promo => !Object.prototype.hasOwnProperty.call(sessionStorage, `dismissPromo-${promo.id}`)
					);
				});
		},
		shouldCreatePromoBar(promo) {
			// Quick and dirty fix to avoid having Affirm promos for Canadian users.
			if (this.countryCode == "CA" && promo.title.toLowerCase("affirm")) {
				return false;
			}

			const BANNER_TYPES = CONSTANTS.PROMOS.BANNER;
			const validPromo =
				this.promos.length &&
				!!promo &&
				!sessionStorage.getItem(`dismissPromo-${promo.id}`);
			let validRoute = false;

			switch (true) {
				case this.$route.name == "step4":
					break;
				case promo.promo_types_id == BANNER_TYPES.ALL:
					validRoute = true;
					break;
				case promo.promo_types_id == BANNER_TYPES.ONLY_HOME:
					validRoute = this.$route.name == "home";
					break;
				case promo.promo_types_id == BANNER_TYPES.ALL_BUT_HOME:
					validRoute = this.$route.name != "home";
					break;
				case promo.promo_types_id == BANNER_TYPES.ALL_BUT_MOBILE_CONFIG:
					validRoute =
						(isMobile() &&
							!["step1", "step2", "step3", "step4-mobile"].includes(
								this.$route.name
							)) ||
						!isMobile();
					break;
				case promo.promo_types_id == BANNER_TYPES.ALL_BUT_REFURB_BUILDS:
					validRoute = this.$route.name != "refurbished-builds";
					break;
				case promo.promo_types_id ==
					BANNER_TYPES.ALL_BUT_MOBILE_CONFIG_REFURB_BUILDS:
					validRoute =
						((isMobile() &&
							!["step1", "step2", "step3", "step4-mobile"].includes(
								this.$route.name
							)) ||
							!isMobile()) &&
						this.$route.name != "refurbished-builds";
					break;
				case promo.promo_types_id == BANNER_TYPES.ONLY_REFURB_BUILDS:
					validRoute = this.$route.name == "refurbished-builds";
					break;
			}

			if (["pc-rental", "stream-build", "step5"].includes(this.$route.name)) {
				validRoute = false;
			}

			return validPromo && validRoute;
		},
		removePromo(promoId) {
			this.promos = this.promos.filter(promo => promo.id != promoId);
		}
	}
};
</script>
